
import RefreshSquare2 from "../../../assets/duotone/RefreshSquare2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RefreshSquare2Icon({ className, dataTestid = "RefreshSquare2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RefreshSquare2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
